import { useGraphqlQuery, TUser } from "@harea/component";
import { EmployeeGenderQuery } from "../query/EmployeeGenderQuery";

export const useEmployeeGenderQuery = (employeeId?: number) => {
    const { data } = useGraphqlQuery<EmployeeGenderQuery, TUser | null>(
        new EmployeeGenderQuery({ employeeId }),
        { enabled: !!employeeId && employeeId !== -1 }
    );

    return data?.employee?.gender;
};
